export const video_grid =
  window.screen.width <= 480
    ? { gutter: 25, column: 1 }
    : window.screen.width <= 1024
    ? { gutter: 25, column: 2 }
    : { gutter: 15, column: 3 };
